import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";
import formatDate from "../utils/formatDate";

// TODO: update endpoint URL to match your actual API
export const getJurnalSiswa = createAsyncThunk(
    "jurnalSiswa/get",
    async ({ start_time, end_time, search } = {}, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                getBaseUrl + '/api/jurnal-kelas',
                {
                    headers: { Authorization: `Bearer ${token()}` },
                    params: { start_time, end_time, search },
                    timeout: 20000
                }
            );
            return response.data;
        } catch (error) {
            if (axios.isCancel(error)) throw new Error('Request canceled');
            if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
            if (error.response?.data?.admin === false) return rejectWithValue('Permission denied');
            return rejectWithValue(error.message);
        }
    }
);

const jurnalSiswaSlice = createSlice({
    name: 'jurnalSiswa',
    initialState: {
        listTabbar: [
            { kategori: 'Belum Divalidasi', id: 1 },
            { kategori: 'Valid', id: 2 },
            { kategori: 'Tidak Valid', id: 3 },
        ],
        jurnalBelumDivalidasi: [],
        jurnalValid: [],
        jurnalTidakValid: [],

        currentKategori: null,
        keterangan: 'Belum Divalidasi',
        currentPage: 1,
        kelas:'',

        search: '',
        startText: 'Tanggal mulai',
        endText: 'Tanggal berakhir',
        startTime: formatDate(new Date()),
        endTime: null,

        loading: false,
        statusResApi: '',
        messageResApi: '',
        isDisplayMessage: false,
    },
    reducers: {
        updateStateJurnalSiswa: (state, action) => {
            const { name, value } = action.payload;
            state[name] = value;
        },
        setCurrentKategoriJurnalSiswa: (state, action) => {
            state.currentKategori = action.payload;
        },
        setKategoriIdJurnalSiswa: (state, action) => {
            // kept for Tabbar compatibility
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getJurnalSiswa.pending, (state) => {
                state.loading = true;
            })
            .addCase(getJurnalSiswa.fulfilled, (state, action) => {
                state.loading = false;
                state.jurnalBelumDivalidasi = action.payload.data.belum_divalidasi;
                state.jurnalValid = action.payload.data.valid;
                state.jurnalTidakValid = action.payload.data.tidak_valid;
                state.kelas = action.payload.kelas;
            })
            .addCase(getJurnalSiswa.rejected, (state, action) => {
                state.loading = false;
                state.statusResApi = action.error.message;
                state.messageResApi = action.payload;
                state.isDisplayMessage = true;
            });
    }
});

export const {
    updateStateJurnalSiswa,
    setCurrentKategoriJurnalSiswa,
    setKategoriIdJurnalSiswa,
} = jurnalSiswaSlice.actions;
export default jurnalSiswaSlice.reducer;
